import clsx from 'clsx';
import React, { forwardRef, memo, useMemo } from 'react';
import { colorToken, dimension, overrideProps, useStyleProps } from '../utils';
import { convertIconPropsToPackIcon, getPackIconFromChildren } from './pack-utils';
import style from './styles.module.css';
/**
 * Компонент предоставляет удобную обертку для работы с `svg` иконками.
 */
export const Icon = overrideProps(/*#__PURE__*/memo(/*#__PURE__*/forwardRef(function Icon(props, ref) {
  const {
    children,
    className,
    size = null,
    height = null,
    width = null,
    color,
    'data-testid': testId = 'icon'
  } = props;
  const styles = useStyleProps({
    color,
    height,
    width,
    size
  }, {
    color: ['--icon-color', colorToken],
    width: ['width', dimension],
    height: ['height', dimension],
    size: [['width', 'height'], dimension]
  });
  // Если передана иконка из пака иконок,
  // то надо вывести ее напрямую,
  // передав ей пропсы
  const iconFromPack = useMemo(() => {
    const icon = getPackIconFromChildren(children);
    return icon ? /*#__PURE__*/React.cloneElement(icon, convertIconPropsToPackIcon(props)) : null;
  }, [children, props]);
  if (iconFromPack) {
    return iconFromPack;
  }
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: clsx(style.icon, className),
    role: "presentation",
    "data-testid": testId,
    ...styles
  }, children);
})));